import {
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { MultipleUpdatesDescription } from '../../components/FormDescriptions/BeneficiaryDescriptions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['app-status--type-title'];
const INPUT_LABEL = content['app-status--type-label'];

const SCHEMA_LABELS = {
  new: content['app-status--type-option--new'],
  existing: content['app-status--type-option--existing'],
};

const SCHEMA_DESCRIPTIONS = {
  new: content['app-status--type-option--new-description'],
  existing: content['app-status--type-option--existing-description'],
};

const SCHEMA_ENUM = Object.keys(SCHEMA_LABELS);

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    submissionType: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
      descriptions: SCHEMA_DESCRIPTIONS,
      tile: true,
    }),
  },
  schema: {
    type: 'object',
    required: ['submissionType'],
    properties: {
      submissionType: radioSchema(SCHEMA_ENUM),
    },
  },
  ContentBeforeButtons: MultipleUpdatesDescription,
};
